<template>
  <v-select
    v-model="c_contract"
    :items="contracts"
    label="Contract"
    class="ma-1"
    :loading="loading"
    return-object hide-details dense outlined
  />
</template>


<script>

  import contract_repository from '@/repositories/contract-repository'

  export default {

    props: {
      contract: null,
    },

    computed: {
      c_contract: {
        get() { return this.contract; },
        set(val) { this.$emit("update:contract", val); }
      }
    },

    data: () => ({
      contracts: [],
      loading: false
    }),

    async created() {
      await this.getContracts()
    },

    methods: {
      async getContracts() {
        try {
          this.loading = true;
          this.contracts = await contract_repository.getContracts(null, {page: 1, size: Number.MAX_SAFE_INTEGER}, {hotel: this.$route.params.hotel, dropdown: true});

          if (!this.contract)
            this.c_contract = _.head(this.contracts) ? _.head(this.contracts) : null;

        } catch (e) {
          await this.$store.dispatch('alert/error', e);
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>